import script from "./portfoliosFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./portfoliosFilter.vue?vue&type=script&setup=true&lang=ts"

import "./portfoliosFilter.vue?vue&type=style&index=0&id=6893414c&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6893414c"]])

export default __exports__